import { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

const LiveQuizSocketCtx = createContext(null);
export const useLiveQuizSocket = () => useContext(LiveQuizSocketCtx);

export function LiveQuizSocketProvider({ children }) {
    const socketRef = useRef(null);
    const [socket, setSocket] = useState(null);
    const [invite, setInvite] = useState(null);
    const [activeRoom, setActiveRoom] = useState(() => {
        const saved = sessionStorage.getItem("lq_activeRoom");
        return saved ? JSON.parse(saved) : null;
    });
    const [hostActiveRoom, setHostActiveRoom] = useState(() => {
        const saved = sessionStorage.getItem("lq_hostActiveRoom");
        return saved ? JSON.parse(saved) : null;
    });

    useEffect(() => {
        if (activeRoom) {
            sessionStorage.setItem("lq_activeRoom", JSON.stringify(activeRoom));
        } else {
            sessionStorage.removeItem("lq_activeRoom");
        }
    }, [activeRoom]);

    useEffect(() => {
        if (hostActiveRoom) {
            sessionStorage.setItem("lq_hostActiveRoom", JSON.stringify(hostActiveRoom));
        } else {
            sessionStorage.removeItem("lq_hostActiveRoom");
        }
    }, [hostActiveRoom]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        if (!token) return;

        const s = io(
            `${process.env.REACT_APP_API_URL || "https://app.fintogo.ai"}/livequiz`,
            { auth: { token }, transports: ["polling", "websocket"] }
        );
        socketRef.current = s;
        setSocket(s);

        const classId = user.classId || user.school_class;
        const role = user.role || user.user_type;

        // Register class AFTER connection is established (and on every reconnect)
        s.on("connect", () => {
            if (classId && role === "student") {
                s.emit("register_class", { classId });
                console.log(`[Live Quiz] registered class room: ${classId}`);
            }
        });

        s.on("quiz_popup", (data) => setInvite(data));
        s.on("quiz_finished", () => setActiveRoom(null));
        s.on("teacher_left", () => setActiveRoom(null));
        s.on("connect_error", (e) => console.error("[Live Quiz] connect error:", e.message));
 
        return () => s.disconnect();
    }, []);

    return (
        <LiveQuizSocketCtx.Provider value={{ socket, invite, setInvite, activeRoom, setActiveRoom, hostActiveRoom, setHostActiveRoom }}>
            {children}
        </LiveQuizSocketCtx.Provider>
    );
}
